/**
 * Copyright (c) 2026, CheckPlus Limited
 */
/**
 * Shared upgrade prompt for manual payment methods.
 */
import React from "react";
import PropTypes from "prop-types";

const UpgradeNoticeCard = ({ heading, body, buttonLabel, onUpgradeClick }) => (
  <div className="UpgradeNoticeCard-container">
    <div className="UpgradeNoticeCard-card">
      <div className="UpgradeNoticeCard-heading">{heading}</div>
      <div className="UpgradeNoticeCard-body">{body}</div>
      <button
        type="button"
        className="UpgradeNoticeCard-btn"
        onClick={onUpgradeClick}
      >
        {buttonLabel}
      </button>
    </div>
  </div>
);

UpgradeNoticeCard.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.node,
  buttonLabel: PropTypes.string,
  onUpgradeClick: PropTypes.func,
};

UpgradeNoticeCard.defaultProps = {
  heading: "Enable Manual Payments",
  body:
    "Manual payment options such as Alipay, WeChat Pay, BoC Pay, Octopus, FPS, Bank Transfer, Cheque, and Cash are available on the Premium plan. Upgrade to unlock them for your organisation.",
  buttonLabel: "Upgrade Now",
  onUpgradeClick: undefined,
};

export default UpgradeNoticeCard;
